import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

import { defaultMST1011_R01Filter, useMST1011_R01Store } from "./Store_MST1011_R01";

export const SearchSection_MST1011_R01 = () => {

  const { brandCdList, itemGroupList, itemAccountList } = useCommonCodeStore();
  const { MST1011_R01Filter, setMST1011_R01Filter } = useMST1011_R01Store();
  const { setCodeSearchModalProps } = useUiuxStore();
  const searchItemCdFocusId = "searchItemCd_MST1011_R01";

  const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
    {
      fieldName: "itemCd",
      category: "품목코드",
      focusId: searchItemCdFocusId,
      responseMapping: {
        itemCd: "itemCd",
        itemNm: "itemNm",
      },
      extraFilter: () => ({
        itemCd: MST1011_R01Filter.itemCd || "",
        itemNm: MST1011_R01Filter.itemNm || "",
      }),
    },
  ];

  const { getFieldHandlers } = useInfoFormEvents({
    editData: MST1011_R01Filter,
    setEditData: setMST1011_R01Filter,
    defaultData: defaultMST1011_R01Filter,
    infoFieldConfigs,
    setCodeSearchModalProps,
    formName: "MST1011_R01_search",
  });

  return (
	<SearchSectionForm>
		<SearchDropDownForm
			label="브랜드"
			value={MST1011_R01Filter.brandCd}
			optionList={brandCdList}
			onChangeItem={(selectedItem) => setMST1011_R01Filter({ brandCd: selectedItem?.minorCd || ''})}	
		/>
		<SearchDropDownForm
			label="품목그룹"
			value={MST1011_R01Filter.itemGroup}
			optionList={itemGroupList}
			onChangeItem={(selectedItem) => setMST1011_R01Filter({ itemGroup: selectedItem?.minorCd || ''})}
		/>
		<SearchDropDownForm
			label="품목계정"
			value={MST1011_R01Filter.itemAccount}
			optionList={itemAccountList}
			onChangeItem={(selectedItem) => setMST1011_R01Filter({ itemAccount: selectedItem?.minorCd || ''})}
		/>
		<SearchCodeModalForm
			label="품목코드"
			value={MST1011_R01Filter.itemCd}
			valueLabel={MST1011_R01Filter.itemNm}
			handleFoucsId={searchItemCdFocusId}
			onChange={getFieldHandlers("itemCd").onChange}
			onDoubleClick={getFieldHandlers("itemCd").onDoubleClick}
			onKeyDown={getFieldHandlers("itemCd").onEnterKeyDown}
		/>
	</SearchSectionForm>
  )
}
